var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 847,
    height: 749,
    viewBox: "0 0 847 749",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M844.451 485.762C852.184 378.641 669.969 278.189 437.463 261.396C204.956 244.603 10.2041 317.828 2.47129 424.949C-5.26156 532.069 176.953 632.521 409.46 649.314C641.966 666.107 836.718 592.882 844.451 485.762Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.976 463.397C832.01 358.666 650.157 268.422 422.796 261.832C195.434 255.241 8.66087 334.799 5.62652 439.53C2.59216 544.26 184.445 634.504 411.807 641.095C639.169 647.686 825.942 568.128 828.976 463.397Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.316 632.984C636.496 629.377 815.261 543.477 813.6 441.122C811.939 338.767 630.48 258.716 408.301 262.324C186.121 265.932 7.35537 351.831 9.01646 454.186C10.6776 556.541 192.136 636.592 414.316 632.984Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.717 624.805C633.739 610.995 804.515 518.752 798.157 418.773C791.798 318.794 610.713 248.939 393.691 262.749C176.669 276.559 5.89291 368.802 12.2515 468.781C18.61 568.761 199.696 638.615 416.717 624.805Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.071 616.656C630.96 592.658 793.775 494.092 782.728 396.503C771.681 298.914 590.955 239.257 379.066 263.255C167.177 287.253 4.36255 385.819 15.4095 483.408C26.4564 580.997 207.182 640.654 419.071 616.656Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.379 608.573C628.097 574.379 782.912 469.459 767.168 374.227C751.423 278.996 571.082 229.515 364.364 263.708C157.646 297.902 2.83116 402.822 18.5755 498.054C34.3198 593.286 214.661 642.767 421.379 608.573Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.807 600.384C625.378 555.98 772.214 444.728 751.775 351.897C731.336 259.065 551.362 219.806 349.79 264.21C148.219 308.613 1.38259 419.865 21.8216 512.697C42.2606 605.529 222.235 644.787 423.807 600.384Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.17 592.271C622.568 537.68 761.404 420.083 736.27 329.611C711.135 239.139 531.548 210.051 335.15 264.642C138.752 319.233 -0.0838946 436.83 25.0506 527.302C50.1852 617.774 229.773 646.862 426.17 592.271Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.601 584.031C619.823 519.215 750.65 395.272 720.812 307.197C690.974 219.123 511.77 200.268 320.548 265.085C129.326 329.901 -1.50191 453.844 28.3361 541.919C58.1742 629.993 237.379 648.848 428.601 584.031Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.005 575.906C617.084 500.895 739.939 370.61 705.409 284.908C670.879 199.205 492.04 190.539 305.961 265.551C119.882 340.562 -2.97327 470.847 31.5567 556.549C66.0867 642.251 244.926 650.918 431.005 575.906Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.388 567.825C614.308 482.63 729.173 346.001 689.947 262.656C650.72 179.311 472.256 180.811 291.336 266.006C110.416 351.202 -4.44902 487.831 34.7777 571.176C74.0044 654.521 252.468 653.021 433.388 567.825Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.812 559.617C611.563 464.207 718.424 321.228 674.495 240.264C630.565 159.301 452.479 171.012 276.728 266.422C100.978 361.831 -5.88346 504.81 38.0463 585.774C81.9762 666.738 260.062 655.026 435.812 559.617Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.166 551.479C608.766 445.881 707.658 296.582 659.048 218.009C610.439 139.436 432.735 161.344 262.135 266.942C91.5355 372.54 -7.35681 521.839 41.2528 600.412C89.8624 678.985 267.567 657.077 438.166 551.479Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.6 543.254C606.035 427.428 696.929 271.771 643.617 195.586C590.305 119.4 412.975 151.535 247.54 267.361C82.1052 383.188 -8.78848 538.844 44.5235 615.03C97.8354 691.215 275.165 659.08 440.6 543.254Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.925 535.045C603.205 409.02 686.107 247.012 628.092 173.19C570.077 99.367 393.114 141.685 232.835 267.71C72.5553 393.735 -10.3466 555.743 47.6682 629.566C105.683 703.388 282.646 661.07 442.925 535.045Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.245 526.949C600.378 390.722 675.314 222.379 612.617 150.944C549.921 79.5098 373.336 132.035 218.203 268.263C63.0698 404.49 -11.8652 572.833 50.8308 644.268C113.527 715.702 290.112 663.177 445.245 526.949Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.641 518.769C597.593 372.347 664.526 197.674 597.139 128.625C529.752 59.5771 353.563 122.301 203.61 268.723C53.6574 415.146 -13.2752 589.819 54.1119 658.867C121.499 727.915 297.688 665.191 447.641 518.769Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.045 510.622C594.843 353.994 653.785 172.968 581.696 106.289C509.607 39.6093 333.785 112.527 188.987 269.155C44.1887 425.783 -14.7536 606.809 57.3356 673.489C129.425 740.168 305.247 667.25 450.045 510.622Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.398 502.452C592.044 335.629 643.018 148.272 566.252 83.9773C489.485 19.6826 314.048 102.798 174.402 269.62C34.7551 436.442 -16.2191 623.799 60.5474 688.094C137.314 752.389 312.751 669.274 452.398 502.452Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.785 494.25C589.262 317.228 632.241 123.531 550.78 61.6151C469.319 -0.300593 294.266 93.0113 159.788 270.033C25.3107 447.055 -17.6679 640.752 63.793 702.668C145.254 764.584 320.307 671.272 454.785 494.25Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.174 486.09C586.482 298.877 621.466 98.8457 535.312 39.3077C449.158 -20.2303 274.491 83.2705 145.183 270.483C15.8741 457.696 -19.1096 657.727 67.0443 717.265C153.198 776.803 327.865 673.303 457.174 486.09Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.578 478.071C583.762 280.666 610.784 74.2819 519.934 17.0996C429.084 -40.0826 254.764 73.5907 130.58 270.996C6.39566 468.401 -20.6266 674.786 70.2238 731.968C161.074 789.15 335.394 675.477 459.578 478.071Z",
    stroke: "#B3B3B3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.9569ff4796574d46b4419e7ad079dc50.svg";
export { ForwardRef as ReactComponent };